class CampaignCompliance extends HTMLElement {
  constructor() {
    super();
    this.checkoutBtn = document.getElementById('checkout');
    this.inputs = [...this.querySelectorAll('.campaign-compliance__input')];
    this.validate = this.validate.bind(this);
  }

  connectedCallback() {
    if (this.checkoutBtn) {
      this.checkoutBtn.addEventListener('click', this.validate);
    }
  }

  disconnectedCallback() {
    if (this.checkoutBtn) {
      this.checkoutBtn.removeEventListener('click', this.validate);
    }
  }

  validate(event) {
    let isValid = true;

    this.inputs.forEach((input) => {
      input.value = input.value.trim();
      const isEmpty = input.value.length < 1;
      const isUncheckedCheckbox = input.type === 'checkbox' && !input.checked;

      if (isEmpty || isUncheckedCheckbox) {
        input.classList.add('inputFieldError');
        isValid = false;
      } else {
        input.classList.remove('inputFieldError');
      }
    });

    // Prevent checkout if invalid
    if (!isValid) {
      event.preventDefault();
    }
  }
}

customElements.define('campaign-compliance', CampaignCompliance);